// One explicit file per technology page; reusable UI primitives live in ui.js.
module.exports = {
  'chatgpt-and-openai': require('./ChatGPTOpenAIPage'),
  'claude-and-anthropic': require('./ClaudeAnthropicPage'),
  'google-gemini': require('./GoogleGeminiPage'),
  'microsoft-foundry': require('./MicrosoftFoundryPage'),
  'amazon-bedrock': require('./AmazonBedrockPage'),
  'mistral-and-open-model-ecosystems': require('./MistralOpenModelsPage'),
  'typescript-and-javascript': require('./TypeScriptJavaScriptPage'),
  'python': require('./PythonPage'),
  'c-sharp-and-net': require('./CSharpDotNetPage'),
  'java-and-kotlin': require('./JavaKotlinPage'),
  'swift': require('./SwiftPage'),
  'go-and-rust': require('./GoRustPage'),
  'sql': require('./SQLPage'),
  'dart-ruby-and-php': require('./DartRubyPHPPage'),
  'c-plus-plus-and-specialized-ecosystems': require('./CppSpecializedEcosystemsPage'),
  'ios': require('./IOSAppDevelopmentPage'),
  'api-design-and-engineering': require('./APIDesignEngineeringPage'),
  'enterprise-connectors': require('./EnterpriseConnectorsPage'),
  'event-driven-workflows': require('./EventDrivenWorkflowsPage'),
  'custom-libraries-and-sdks': require('./CustomLibrariesSDKsPage'),
  'design-systems': require('./DesignSystemsPage'),
  'developer-platforms': require('./DeveloperPlatformsPage'),
  'operational-storage': require('./OperationalStoragePage'),
  'pipelines-and-analytics': require('./PipelinesAnalyticsPage'),
  'retrieval-and-search': require('./RetrievalSearchPage'),
  'cloud-architecture': require('./CloudArchitecturePage'),
  'delivery-automation': require('./DeliveryAutomationPage'),
  'observability-and-reliability': require('./ObservabilityReliabilityPage'),
  'identity-and-application-security': require('./IdentityApplicationSecurityPage'),
  'automated-quality-engineering': require('./AutomatedQualityEngineeringPage'),
  'secure-delivery-and-continuity': require('./SecureDeliveryContinuityPage'),
  'retrieval-augmented-generation': require('./RetrievalAugmentedGenerationPage'),
  'tools-agents-and-orchestration': require('./ToolsAgentsOrchestrationPage'),
  'llmops-and-evaluation': require('./LLMOpsEvaluationPage'),
  'inference-and-cost-engineering': require('./InferenceCostEngineeringPage'),
};
